<div class="mb-3 row" [style.display]="formGroup.get('articleDescription').disabled ? 'none' : ''"> <label
    for="articleDescription" class="col-md-4 control-label text-start">{{'ARTICLEDESCRIPTION'|translate}}</label>
  <div class="col-md-6" [formGroup]="formGroup"> <input type="text" class="form-control" id="articleDescription"
      formControlName="articleDescription" name="articleDescription" maxlength="60"> </div>
</div>
